import React from 'react'
import { Route, Switch } from 'react-router-dom'
import Loadable from './Loadable'
import { PREFIX } from 'Lib'
// import ContentAdd from 'material-ui/SvgIcon';

const AsyncHome = Loadable({
    loader: () => import('../../ui/components/Home')
})

const AsyncNotFound = Loadable({
    loader: () => import('../../ui/components/NotFound')
})

const AsyncLoginBSRS = Loadable({
    loader: () => import('../../auth/components/LoginBSRS')
})

const AsyncTest = Loadable({
    loader: () => import('../../test/components/image')
})

// const AsyncUsers = Loadable({
//     loader: () => import('../../users/components/Users')
// })

// const AsyncCreateSyncUser = Loadable({
//     loader: () => import('../../users/components/CreateUser')
// })

// const AsyncCreateSyncUserWithoutEmail = Loadable({
//     loader: () => import('../../users/components/CreateUserWithoutEmail')
// })
const AsyncChangePassword = Loadable({
    loader: () => import('../../users/components/ChangePassword')
})

const AsyncForgotPassword = Loadable({
    loader: () => import('../../users/components/ForgotPassword')
})

const AsyncFirstChangePassword = Loadable({
    loader: () => import('../../users/components/FirstChangePassword')
})


const AsyncRoomLocal = Loadable({
    loader: () => import('../../rooms/components/RoomLocal')
})

const AsyncDisableRoom = Loadable({
    loader: () => import('../../rooms/components/DisableRoom')
})

const AsyncCreateDisableRoom = Loadable({
    loader: () => import('../../rooms/components/CreateDisableRoom')
})

const AsyncEditDisableRoom = Loadable({
    loader: () => import('../../rooms/components/EditDisableRoom')
})

const AsyncCreateRoom = Loadable({
    loader: () => import('../../rooms/components/CreateRoom')
})

const AsyncEditRoom = Loadable({
    loader: () => import('../../rooms/components/EditRoom')
})

// const AsyncLocalUsers = Loadable({
//     loader: () => import('../../users/components/UsersLocal')
// })

const AsyncLocalEditUsers = Loadable({
    loader: () => import('../../users/components/UsersLocalEdit')
})

const AsyncQRcode = Loadable({
    loader: () => import('../../rooms/components/CreateQRcode')
})

const AsyncWithOutPermission = Loadable({
    loader: () => import('../../ui/components/WithOutPermission')
})

const AsyncImage = Loadable({
    loader: () => import('../../test/components/image')
})

const AsyncUserList = Loadable({
    loader: () => import('../../users/components/UserList')
})

// const AsyncFBS = Loadable({
//     loader: () => import('../../fbs/components/Fbs')
// })

const AsyncFBSlist = Loadable({
    loader: () => import('../../fbs/components/FBSlist')
})

const AsyncFBSEdit = Loadable({
    loader: () => import('../../fbs/components/EditFbs')
})

const AsyncFBScreate = Loadable({
    loader: () => import('../../fbs/components/CreateFbs')
})

const AsyncBuilding = Loadable({
    loader: () => import('../../buildings/components/Building')
})

const AsyncCreateBuilding = Loadable({
    loader: () => import('../../buildings/components/CreateBuilding')
})

const AsyncEditBuilding = Loadable({
    loader: () => import('../../buildings/components/EditBuilding')
})

const AsyncRoomFormat = Loadable({
    loader: () => import('../../roomFormat/components/RoomFormat')
})

const AsyncCreateRoomFormat = Loadable({
    loader: () => import('../../roomFormat/components/CreateRoomFormat')
})

const AsyncEditRoomFormat = Loadable({
    loader: () => import('../../roomFormat/components/EditRoomFormat')
})

const AsyncFbsCategory = Loadable({
    loader: () => import('../../fbsCategory/components/FbsCategoryList')
})
const AsyncCreateFBSCategory = Loadable({
    loader: () => import('../../fbsCategory/components/CreateFBSCategory')
})
const AsyncEditFBSCategory = Loadable({
    loader: () => import('../../fbsCategory/components/EditFBSCategory')
})


const AsyncFloors = Loadable({
    loader: () => import('../../floors/components/Floors')
})

const AsyncCreateFloor = Loadable({
    loader: () => import('../../floors/components/CreateFloor')
})

const AsyncEditFloor = Loadable({
    loader: () => import('../../floors/components/EditFloor')
})

const AsyncHolidays = Loadable({
    loader: () => import('../../holidays/components/Holidays')
})

const AsyncCreateHoliday = Loadable({
    loader: () => import('../../holidays/components/CreateHoliday')
})

const AsyncEditHoliday = Loadable({
    loader: () => import('../../holidays/components/EditHoliday')
})

const AsyncAmenitylist = Loadable({
    loader: () => import('../../amenity/components/Amenitylist')
})

const AsyncAmenityEdit = Loadable({
    loader: () => import('../../amenity/components/EditAmenity')
})

const AsyncAmenitycreate = Loadable({
    loader: () => import('../../amenity/components/CreateAmenity')
})

const AsyncSetting = Loadable({
    loader: () => import('../../setting/components/SettingView')
})

const AsyncSettingEdit = Loadable({
    loader: () => import('../../setting/components/SettingEdit')
})

const AsyncSettingEmail = Loadable({
    loader: () => import('../../setting/components/SettingEmail')
})

const AsyncTitle = Loadable({
    loader: () => import('../../title/components/TitleList')
})

const AsyncCreateTitle = Loadable({
    loader: () => import('../../title/components/CreateTitle')
})

const AsyncEditTitle = Loadable({
    loader: () => import('../../title/components/EditTitle')
})

const AsyncCreateLocalUser = Loadable({
    loader: () => import('../../users/components/UsersLocalCreate')
})

const AsyncUserInfo = Loadable({
    loader: () => import('../../users/components/UserInfo')
})


const AsyncEventReport = Loadable({
    loader: () => import('../../report/components/EventReportNewConcept')
})

const AsyncAdminReport = Loadable({
    loader: () => import('../../report/components/AdminReport')
})
const AsyncRoomUsageByNameReport = Loadable({
    loader: () => import('../../report/components/RoomUsageByNameReport')
})

const AsyncRoomUsageByTypeReport = Loadable({
    loader: () => import('../../report/components/RoomUsageByTypeReport')
})

const AsyncUsageByUserReport = Loadable({
    loader: () => import('../../report/components/UsageByUserReport')
})

const AsyncFBSSummaryReport = Loadable({
    loader: () => import('../../report/components/FBSSummaryReport')
})

const AsyncAmenitiesSummaryReport = Loadable({
    loader: () => import('../../report/components/AmenitiesSummaryReport')
})

const AsyncTermForm = Loadable({
    loader: () => import('../../setting/components/TermForm')
})

const AsyncTermForTrainingRoomForm = Loadable({
    loader: () => import('../../setting/components/TermForTrainingRoomForm')
})

const AsyncTerm = Loadable({
    loader: () => import('../../setting/components/Term')
})

const TermForTrainingRoom = Loadable({
    loader: () => import('../../setting/components/TermForTrainingRoom')
})

const AsyncUploadUsers = Loadable({
    loader: () => import('../../uploadfile/components/Users')
})

const AsyncUploadRooms = Loadable({
    loader: () => import('../../uploadfile/components/Rooms')
})

const AsyncUploadEvents = Loadable({
    loader: () => import('../../uploadfile/components/Events')
})

//Department
const AsyncDepartments = Loadable({
    loader: () => import('../../department/components/Departments')
})
const AsyncCreateDepartment = Loadable({
    loader: () => import('../../department/components/CreateDepartment')
})
const AsyncEditDepartment = Loadable({
    loader: () => import('../../department/components/EditDepartment')
})

//Room Type
const AsyncRoomTypes = Loadable({
    loader: () => import('../../roomType/components/RoomTypes')
})
const AsyncCreateRoomType = Loadable({
    loader: () => import('../../roomType/components/CreateRoomType')
})
const AsyncEditRoomType = Loadable({
    loader: () => import('../../roomType/components/EditRoomType')
})

export default () => (
    <Switch>
        <Route exact path={`${PREFIX}/`} component={AsyncHome} />
        <Route path={`${PREFIX}/login`} component={AsyncLoginBSRS} />
        <Route path={`${PREFIX}/img`} component={AsyncImage} />
        <Route path={`${PREFIX}/withoutpermission`} component={AsyncWithOutPermission} />

        <Route path={`${PREFIX}/department/edit/:id`} component={AsyncEditDepartment} />
        <Route path={`${PREFIX}/department/create`} component={AsyncCreateDepartment} />
        <Route path={`${PREFIX}/departments`} component={AsyncDepartments} />

        <Route path={`${PREFIX}/roomtype/edit/:id`} component={AsyncEditRoomType} />
        <Route path={`${PREFIX}/roomtype/create`} component={AsyncCreateRoomType} />
        <Route path={`${PREFIX}/roomtype`} component={AsyncRoomTypes} />

        {/* <Route path={`${PREFIX}/user/sync/create/:email/:system`} component={AsyncCreateSyncUser} />
        <Route path={`${PREFIX}/user/sync/edit/:id`} component={AsyncEditSyncUser} />
        <Route path={`${PREFIX}/user/sync/create`} component={AsyncCreateSyncUserWithoutEmail} />
        <Route path={`${PREFIX}/user/sync`} component={AsyncUsers} /> */}
        <Route path={`${PREFIX}/user/local/create`} component={AsyncCreateLocalUser} />
        <Route path={`${PREFIX}/user/local/edit/:id`} component={AsyncLocalEditUsers} />
        <Route path={`${PREFIX}/user/changePassword/:id`} component={AsyncChangePassword} />
        <Route path={`${PREFIX}/user/firstChangePassword/:id`} component={AsyncFirstChangePassword} />
        <Route path={`${PREFIX}/user/local`} component={AsyncUserList} />
        <Route path={`${PREFIX}/user/info`} component={AsyncUserInfo} />
        <Route path={`${PREFIX}/reset/:id`} component={AsyncForgotPassword} />

        <Route path={`${PREFIX}/room/qrcode/:id`} component={AsyncQRcode} />
        <Route path={`${PREFIX}/room/edit/:id`} component={AsyncEditRoom} />
        <Route path={`${PREFIX}/room/create`} component={AsyncCreateRoom} />

        <Route path={`${PREFIX}/room/disable/edit/:id`} component={AsyncEditDisableRoom} />
        <Route path={`${PREFIX}/room/disable/create`} component={AsyncCreateDisableRoom} />
        <Route path={`${PREFIX}/room/disable`} component={AsyncDisableRoom} />
        <Route path={`${PREFIX}/room`} component={AsyncRoomLocal} />
        <Route path={`${PREFIX}/qrcode`} component={AsyncQRcode} />

        <Route path={`${PREFIX}/fbs/create`} component={AsyncFBScreate} />
        <Route path={`${PREFIX}/fbs/edit/:id`} component={AsyncFBSEdit} />
        <Route path={`${PREFIX}/fbs`} component={AsyncFBSlist} />

        <Route path={`${PREFIX}/title/create`} component={AsyncCreateTitle} />
        <Route path={`${PREFIX}/title/edit/:id`} component={AsyncEditTitle} />
        <Route path={`${PREFIX}/title`} component={AsyncTitle} />

        <Route path={`${PREFIX}/setting/edit/:id`} component={AsyncSettingEdit} />
        <Route path={`${PREFIX}/setting/message`} component={AsyncSettingEmail} />
        <Route path={`${PREFIX}/setting`} component={AsyncSetting} />

        <Route path={`${PREFIX}/amenity/create`} component={AsyncAmenitycreate} />
        <Route path={`${PREFIX}/amenity/edit/:id`} component={AsyncAmenityEdit} />
        <Route path={`${PREFIX}/amenity`} component={AsyncAmenitylist} />

        <Route path={`${PREFIX}/fbsCategory/edit/:id`} component={AsyncEditFBSCategory} />
        <Route path={`${PREFIX}/fbsCategory/create`} component={AsyncCreateFBSCategory} />
        <Route path={`${PREFIX}/fbsCategory`} component={AsyncFbsCategory} />
        <Route path='/test' component={AsyncTest} />

        <Route path={`${PREFIX}/floors`} component={AsyncFloors} />
        <Route path={`${PREFIX}/floor/edit/:id`} component={AsyncEditFloor} />
        <Route path={`${PREFIX}/floor/create`} component={AsyncCreateFloor} />

        <Route path={`${PREFIX}/building/create`} component={AsyncCreateBuilding} />
        <Route path={`${PREFIX}/building/edit/:id`} component={AsyncEditBuilding} />
        <Route path={`${PREFIX}/building`} component={AsyncBuilding} />

        <Route path={`${PREFIX}/holidays`} component={AsyncHolidays} />
        <Route path={`${PREFIX}/holiday/create`} component={AsyncCreateHoliday} />
        <Route path={`${PREFIX}/holiday/edit/:id`} component={AsyncEditHoliday} />

        <Route path={`${PREFIX}/fbssummary`} component={AsyncFBSSummaryReport} />
        <Route path={`${PREFIX}/amenitiessummary`} component={AsyncAmenitiesSummaryReport} />
        <Route path={`${PREFIX}/eventreport`} component={AsyncEventReport} />
        <Route path={`${PREFIX}/adminreport`} component={AsyncAdminReport} />
        <Route path={`${PREFIX}/roombyname`} component={AsyncRoomUsageByNameReport} />
        <Route path={`${PREFIX}/roombytype`} component={AsyncRoomUsageByTypeReport} />
        <Route path={`${PREFIX}/reportbyuser`} component={AsyncUsageByUserReport} />

        <Route path={`${PREFIX}/roomformat/create`} component={AsyncCreateRoomFormat} />
        <Route path={`${PREFIX}/roomformat/edit/:id`} component={AsyncEditRoomFormat} />
        <Route path={`${PREFIX}/roomformat`} component={AsyncRoomFormat} />

        <Route path={`${PREFIX}/editterm/trainingroom/:id`} component={AsyncTermForTrainingRoomForm} />
        <Route path={`${PREFIX}/editterm/:id`} component={AsyncTermForm} />

        <Route path={`${PREFIX}/term/trainingroom`} component={TermForTrainingRoom} />
        <Route path={`${PREFIX}/term`} component={AsyncTerm} />

        <Route path={`${PREFIX}/uploaduser`} component={AsyncUploadUsers} />
        <Route path={`${PREFIX}/uploadrooms`} component={AsyncUploadRooms} />
        <Route path={`${PREFIX}/uploadevents`} component={AsyncUploadEvents} />

        <Route component={AsyncNotFound} />
    </Switch>
)


// WEBPACK FOOTER //
// ./src/features/ui/components/Routes.js